export const CONFIRM_MS = 800; // a new voice must stay dominant this long before we cut
export const WIDE_AFTER_MS = 8000; // nobody talking this long -> room camera (wide shot)
export const SPEAK_LEVEL = 0.08; // analyser RMS (0..1) that counts as "talking"

export const initialSpeakerState = (now = 0) => ({ cur: null, since: 0, cand: null, candSince: 0, lastVoice: now });

/**
 * One 200 ms step of the auto-speaker decision. Pure so the console preview and the cloud
 * recorder behave identically and it can be unit-tested.
 *  list      roster entries { peerId, customId, videoEnabled }
 *  roomCams  Set of customIds flagged as room camera (Owl) — never a cut trigger, wide-shot fallback
 *  raw       SFU activeSpeaker peerId (may lag / point at the room cam)
 *  levels    { peerId: rms 0..1 } from our analysers ({} when unavailable)
 */
export function stepSpeaker(s, { list, roomCams, raw, levels, holdMs, wideFallback }, now) {
  const lv = levels || {};
  const eligible = list.filter((e) => e.videoEnabled && !roomCams.has(e.customId));
  const roomCam = list.find((e) => e.videoEnabled && roomCams.has(e.customId)) || null;
  const haveLevels = Object.keys(lv).length > 0;

  let cand = null;
  const rawE = eligible.find((e) => e.peerId === raw);
  if (rawE && (!haveLevels || (lv[rawE.peerId] || 0) >= SPEAK_LEVEL)) cand = rawE.peerId;
  if (!cand && haveLevels) {
    let best = SPEAK_LEVEL;
    eligible.forEach((e) => { const v = lv[e.peerId] || 0; if (v > best) { best = v; cand = e.peerId; } });
  }
  if (cand) s.lastVoice = now;

  if (cand && cand !== s.cur) {
    if (s.cand !== cand) { s.cand = cand; s.candSince = now; }
    // hold applies to people, not to the wide shot: a voice after silence comes back quickly
    const onWide = !!(roomCam && s.cur === roomCam.peerId);
    if (now - s.candSince >= CONFIRM_MS && (s.cur == null || onWide || now - s.since >= holdMs)) { s.cur = cand; s.since = now; s.cand = null; }
  } else {
    s.cand = null;
  }
  if (wideFallback && roomCam && haveLevels && now - s.lastVoice >= WIDE_AFTER_MS && s.cur !== roomCam.peerId) { s.cur = roomCam.peerId; s.since = now; }
  if (s.cur && !list.some((e) => e.peerId === s.cur && e.videoEnabled)) s.cur = null;
  return s.cur;
}
